import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { BrowserModule } from "@angular/platform-browser";

import { NgxPaginationModule } from 'ngx-pagination';

import { PropertiespreModule } from './pages/propertiespre/propertiespre.module';
import { PropertiesmainModule } from './pages/propertiesmain/propertiesmain.module';
import { GeocodingComponent } from './pages/geocoding/geocoding.component';
import { PropertydetailComponent } from './pages/propertydetail/propertydetail.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

import { ReactiveFormsModule } from '@angular/forms';

import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  declarations: [

    GeocodingComponent,
    PropertydetailComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    SharedModule,
    NgxPaginationModule,
    PropertiespreModule,
    PropertiesmainModule,
    NgxSliderModule,
    MatSliderModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    InfiniteScrollModule
  ]
})
export class WwwPropertiesModule { }
